import React from "react";
import { useReveal } from "../hooks/useReveal";

const IMAGES = [
  { src: "/images/food1.jpg", alt: "Pita mit Tzatziki", className: "row-span-2" },
  { src: "/images/food2.jpg", alt: "Kalamari Salat" },
  { src: "/images/food5.jpg", alt: "Scampi und Kalamari Platte", className: "col-span-2" },
  { src: "/images/food3.jpg", alt: "Griechische Spezialität" },
  { src: "/images/food4.jpg", alt: "Restaurant Poseidon Gericht" },
];

export default function Gallery() {
  const ref = useReveal();
  return (
    <section
      id="impressionen"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 px-6"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14 reveal" ref={ref}>
          <p className="text-gold tracking-[0.4em] text-xs uppercase mb-4">Galerie</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white">
            <span className="italic text-gradient-gold">Impressionen</span>
          </h2>
          <p className="text-white/65 mt-4 max-w-xl mx-auto">
            Ein Blick auf unsere kulinarischen Kreationen – frisch zubereitet in unserer Küche.
          </p>
          <div className="gold-divider w-24 mx-auto mt-6" />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[240px] gap-3 md:gap-4">
          {IMAGES.map((img, i) => (
            <div
              key={i}
              data-testid={`gallery-image-${i}`}
              className={`relative overflow-hidden rounded-2xl group cursor-zoom-in ${img.className || ""}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-4">
                <p className="text-white text-sm font-light">{img.alt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
